// @flow
import { login, logout, regenerateToken, receiveAuth } from './authActions';
import { type ActionType, handleActions } from 'redux-actions';
import AuthState from './AuthState';

export { default as AuthState } from './AuthState';
export default handleActions(
  {
    [login.toString()]: (state: AuthState, action: ActionType<typeof login>) =>
      state.set('requestStatus', 'pending'),

    [regenerateToken.toString()]: (
      state: AuthState,
      action: ActionType<typeof login>
    ) => state.set('requestStatus', 'pending'),

    [logout.toString()]: (state: AuthState, action: ActionType<typeof login>) =>
      new AuthState(),

    [receiveAuth.toString()]: {
      next(state: AuthState, action: ActionType<typeof receiveAuth>) {
        return AuthState.createFromPayload(action.payload);
      },
      throw(state: AuthState, action: ActionType<typeof receiveAuth>) {
        return new AuthState({ requestStatus: action.payload });
      },
    },
  },
  new AuthState()
);



// WEBPACK FOOTER //
// ./src/ducks/authReducer.js